import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetPlanReviewRequirementCodeSectionsMutationVariables = Types.Exact<{
  requirementId: Types.Scalars['uuid']['input'];
  objects: Array<Types.Plan_Review_Requirement_Code_Sections_Insert_Input> | Types.Plan_Review_Requirement_Code_Sections_Insert_Input;
}>;


export type SetPlanReviewRequirementCodeSectionsMutation = { __typename?: 'mutation_root', delete_plan_review_requirement_code_sections?: { __typename?: 'plan_review_requirement_code_sections_mutation_response', affected_rows: number } | null, insert_plan_review_requirement_code_sections?: { __typename?: 'plan_review_requirement_code_sections_mutation_response', affected_rows: number } | null };


export const SetPlanReviewRequirementCodeSectionsDocument = gql`
    mutation setPlanReviewRequirementCodeSections($requirementId: uuid!, $objects: [plan_review_requirement_code_sections_insert_input!]!) {
  delete_plan_review_requirement_code_sections(
    where: {requirement_id: {_eq: $requirementId}}
  ) {
    affected_rows
  }
  insert_plan_review_requirement_code_sections(objects: $objects) {
    affected_rows
  }
}
    `;
export type SetPlanReviewRequirementCodeSectionsMutationFn = Apollo.MutationFunction<SetPlanReviewRequirementCodeSectionsMutation, SetPlanReviewRequirementCodeSectionsMutationVariables>;

/**
 * __useSetPlanReviewRequirementCodeSectionsMutation__
 *
 * To run a mutation, you first call `useSetPlanReviewRequirementCodeSectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPlanReviewRequirementCodeSectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPlanReviewRequirementCodeSectionsMutation, { data, loading, error }] = useSetPlanReviewRequirementCodeSectionsMutation({
 *   variables: {
 *      requirementId: // value for 'requirementId'
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useSetPlanReviewRequirementCodeSectionsMutation(baseOptions?: Apollo.MutationHookOptions<SetPlanReviewRequirementCodeSectionsMutation, SetPlanReviewRequirementCodeSectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPlanReviewRequirementCodeSectionsMutation, SetPlanReviewRequirementCodeSectionsMutationVariables>(SetPlanReviewRequirementCodeSectionsDocument, options);
      }
export type SetPlanReviewRequirementCodeSectionsMutationHookResult = ReturnType<typeof useSetPlanReviewRequirementCodeSectionsMutation>;
export type SetPlanReviewRequirementCodeSectionsMutationResult = Apollo.MutationResult<SetPlanReviewRequirementCodeSectionsMutation>;
export type SetPlanReviewRequirementCodeSectionsMutationOptions = Apollo.BaseMutationOptions<SetPlanReviewRequirementCodeSectionsMutation, SetPlanReviewRequirementCodeSectionsMutationVariables>;